import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'identity-verification-video-modal',
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  template: `
    <div class="video-modal">
      <button mat-icon-button class="video-modal__close" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
      <video
        class="video-modal__player"
        [src]="data.videoUrl"
        controls
        autoplay
        playsinline
      ></video>
    </div>
  `,
  styleUrls: ['./verification-video-modal.component.scss'],
})
export class VerificationVideoModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { videoUrl: string }) { }
}